import React, { Fragment, useCallback, useEffect, useState } from "react"
import { DashboardData, DashboardDataValues } from "../services/authinterface"
import { request } from "../services/request"
import { ToastContainer } from "react-toastify"
// import UserDoughnutChart from "../components/common/subComponents/UserDoughnutChart";
// import ChartDataLabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2"
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js"
import { useDispatch } from "react-redux"
import { changeloaderState } from "../store/loaderSlice"
import { AppDispatch } from "../store/store"
import { DashboardCollectIcon } from "../icons/webSvg"

ChartJS.register(ArcElement, Tooltip, Legend)

const Dashboard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()

  const [dashboardData, setDashboardData] = useState<DashboardDataValues | null>(null)
  const fetchDashboardData = useCallback(async () => {
    try {
      dispatch(changeloaderState(true))

      const response = await request<DashboardData>({
        url: "/adminCustomers/dashboard",
        method: "GET",
      })
      if (response.success) {
        const dashboard = response.data
        setDashboardData(dashboard)
      }
    } catch (error) {
    } finally {
      dispatch(changeloaderState(false))
    }
  }, [dispatch])

  useEffect(() => {
    fetchDashboardData()
  }, [fetchDashboardData])

  return (
    <>
      <section className='dashboard-section'>
        <ToastContainer position='top-right' autoClose={2000} theme='light' />

        <div className='container'>
          <div className='row gap'>
            <div className='col-12 mb-3'>
              <div className='dashboard-table-title-section title-line'>
                <h2>Dashboard Overview</h2>
              </div>
            </div>

            <div className='col-md-7'>
              <div className='row'>
                <div className='col-12 col-sm-6 col-md-6 mb-3'>
                  <div className='dashboard-card'>
                    <div className='dashboard-card-header'>
                      <div className='dashboard-card-icon'>
                        <DashboardCollectIcon />
                      </div>
                    </div>
                    <div className='dashboard-card-details'>
                      <div className='card-details-left'>
                        <h3>${(dashboardData?.revenue?.SOS)?.toFixed(2)}</h3>
                        <h5>Monthly recurring SOS revenue</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-md-6 mb-3'>
                  <div className='dashboard-card'>
                    <div className='dashboard-card-header'>
                      <div className='dashboard-card-icon'>
                        <DashboardCollectIcon />
                      </div>
                    </div>
                    <div className='dashboard-card-details'>
                      <div className='card-details-left'>
                        <h3>${(dashboardData?.revenue?.Sensor)?.toFixed(2)}</h3>
                        <h5>Monthly recurring Sensor revenue</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-md-6 mb-3  h-100'>
                  {dashboardData && (
                    <div className='col-12 col-md-12 col-lg-12 '>
                      <div className='dashboard-card dashboard-card-details gap-0 min-h-300 max-h-300 p-3'>
                        <h5 className="text-lg fw-bold">Sensor Status</h5>
                        <Doughnut
                          data={{
                            labels: ["Active", "Offline"],
                            datasets: [
                              {
                                label: "Total",
                                data: [
                                  dashboardData?.sensorCounts?.totalActiveSensor || 0,
                                  dashboardData?.sensorCounts?.totalInactiveSensor || 0,
                                ],
                                backgroundColor: [
                                  "#36A2EB",
                                  "#FF6384",
                                ],
                                borderWidth: 1,
                              },
                            ],
                          }}
                          options={{
                            layout: {
                              padding: 20, // extra space for tooltips
                            },
                            plugins: {
                              legend: {
                                position: "bottom", // 👈 This moves the labels below the chart
                                labels: {
                                  boxWidth: 20,
                                  padding: 15,
                                },
                              },
                              // datalabels: {
                              //   color: "#000",
                              //   font: {
                              //     weight: "bold",
                              //     size: 14,
                              //   },
                              //   formatter: (value: number) => value, // 👈 Show the raw value
                              // }
                            },

                            maintainAspectRatio: false, // Optional: makes it responsive
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className='col-12 col-sm-6 col-md-6 mb-3  h-100'>
                  {dashboardData && (
                    <div className='col-12 col-md-12 col-lg-12 '>
                      <div className='dashboard-card dashboard-card-details gap-0 min-h-300 max-h-300'>
                      <h5 className="text-lg fw-bold">SOS Status</h5>
                        <Doughnut
                          data={{
                            labels: ["Active", "Offline"],
                            datasets: [
                              {
                                label: "Total",
                                data: [
                                  dashboardData?.sensorCounts?.totalActiveSOS || 0,
                                  dashboardData?.sensorCounts?.totalInactiveSOS || 0,
                                ],
                                backgroundColor: [
                                  "#36A2EB",
                                  "#FF6384",
                                ],
                                borderWidth: 1,
                              },
                            ],
                          }}
                          options={{
                            layout: {
                              padding: 20,
                            },
                            plugins: {
                              legend: {
                                position: "bottom", // 👈 This moves the labels below the chart
                                labels: {
                                  boxWidth: 20,
                                  padding: 15,
                                },
                              },
                              // datalabels: {
                              //   color: "#000",
                              //   font: {
                              //     weight: "bold",
                              //     size: 14,
                              //   },
                              //   formatter: (value: number) => value, // 👈 Show the raw value
                              // }
                            },

                            maintainAspectRatio: false, // Optional: makes it responsive
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
                {/* <div className='col-12 col-sm-6 col-md-6 mb-3'>
                  <div className='dashboard-card'>
                    <div className='dashboard-card-header'>
                      <div className='dashboard-card-icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='32'
                          height='32'
                          fill='#000000'
                          viewBox='0 0 256 256'
                        >
                          <path d='M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,32l80.34,44-29.77,16.3-80.35-44ZM128,120,47.66,76l33.9-18.56,80.34,44ZM40,90l80,43.78v85.79L40,175.82Zm176,85.78h0l-80,43.79V133.82l32-17.51V152a8,8,0,0,0,16,0V107.55L216,90v85.77Z'></path>
                        </svg>
                      </div>
                    </div>
                    <div className='dashboard-card-details'>
                      <div className='card-details-left'>
                        <h3>10</h3>
                        <h5>Active subscriptions by product</h5>
                      </div>
                      <div className='card-details-right'>
                        <h6>+12 new</h6>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div className='col-md-5'>
              <div className='row h-100'>
                {dashboardData && (
                  <div className='col-12 col-md-12 col-lg-12 '>
                    <div className='dashboard-card dashboard-card-details gap-0 min-h-350 max-h-350'>
                      <h5 className="text-lg fw-bold">Users</h5>
                      <Doughnut
                        data={{
                          labels: ["Unique Users", "Owners", "Admins", "Kids", "Viewers", "Police"],
                          datasets: [
                            {
                              label: "Total",
                              data: [
                                dashboardData.totalUsers,
                                dashboardData.totalOwner,
                                dashboardData.totalAdmins,
                                dashboardData.totalKids,
                                dashboardData.totalViewer,
                                dashboardData.totalPolice,
                              ],
                              backgroundColor: [
                                "#36A2EB",
                                "#FF6384",
                                "#FFCE56",
                                "#4BC0C0",
                                "#9966FF",
                                "#FF9F40",
                              ],
                              borderWidth: 1,
                            },
                          ],
                        }}
                        options={{
                          layout: {
                              padding: 20,
                            },
                          plugins: {
                            legend: {
                              position: "bottom", // 👈 This moves the labels below the chart
                              labels: {
                                boxWidth: 20,
                                padding: 15,
                              },
                            },
                            // datalabels: {
                            //   color: "#000",
                            //   font: {
                            //     weight: "bold",
                            //     size: 14,
                            //   },
                            //   formatter: (value: number) => value, // 👈 Show the raw value
                            // }
                          },

                          maintainAspectRatio: false, // Optional: makes it responsive
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Dashboard
